export default {
  title: "From the Publisher..."
};
